import React from "react";
import {
	isSchemaOptimizerJobFailed,
	isSchemaOptimizerJobInFlight,
	isSchemaOptimizerJobSuccess,
} from "../../../services/schemaOptimizerApi";
import { schemaJobStatusLabel } from "./schemaOptimizerUtils";

export default function SchemaOptimizerStatusBadge({ status, className = "" }) {
	const inFlight = isSchemaOptimizerJobInFlight(status);
	const success = isSchemaOptimizerJobSuccess(status);
	const failed = isSchemaOptimizerJobFailed(status);
	let tone = "schema-optimizer__badge--idle";
	if (success) tone = "schema-optimizer__badge--success";
	else if (failed) tone = "schema-optimizer__badge--failed";
	else if (inFlight) tone = "schema-optimizer__badge--running";

	return (
		<span className={`schema-optimizer__badge ${tone} ${className}`.trim()}>
			{schemaJobStatusLabel(status)}
		</span>
	);
}

const RUN_STATUS_LABELS = {
	SUCCESS: "Done",
	RUNNING: "Running",
	PENDING: "Queued",
	PARTIAL: "Partial",
	FAILURE: "Failed",
};

export function SchemaOptimizerRunStatusBadge({ status }) {
	const s = String(status || "").toUpperCase();
	let tone = "schema-optimizer__badge--idle";
	if (s === "SUCCESS") tone = "schema-optimizer__badge--success";
	else if (s === "FAILURE") tone = "schema-optimizer__badge--failed";
	else if (s === "PENDING" || s === "RUNNING" || s === "PARTIAL") {
		tone = "schema-optimizer__badge--running";
	}
	const label = RUN_STATUS_LABELS[s] || status || "—";
	return (
		<span className={`schema-optimizer__badge ${tone}`}>
			{s === "SUCCESS" && <i className="fas fa-check me-1" aria-hidden />}
			{label}
		</span>
	);
}
